import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSuccessfulCreateSnackbar, useFailedCreateSnackbar, LoadingIndicator } from '../../../../Components/CoreLib/library';
import { DEFAULT_SITE_HAULING_LINE_ITEM, SiteHaulingLineItemForm } from '../../../../Components/Forms/QuoteForm';
import { SiteHaulingLineItemDto } from '../../../../dtos';
import { useCreateSiteHaulingLineItemMutation, useLazyGetOrderByIdQuery, useLazyGetQuoteByIdQuery } from '../../../../store/generated/generatedApi';

export const AddSiteHaulingLineItemView: FC = () => {
    const { quoteId, jobId, orderId } = useParams();
    const navigate = useNavigate();
    const [getQuote, { data: quote, isLoading: isQuoteLoading }] = useLazyGetQuoteByIdQuery();
    const [createSiteHaulingLineItem, { isError, isSuccess, reset }] = useCreateSiteHaulingLineItemMutation();
    const [getOrder, { data: order, isLoading: isOrderLoading }] = useLazyGetOrderByIdQuery();

    useEffect(() => {
        if (quoteId && !quote) {
            getQuote({ id: quoteId! });
        }
    }, [getQuote, quote, quoteId]);

    useEffect(() => {
        if (orderId && !order) {
            getOrder({ id: orderId! });
        }
    }, [getOrder, order, orderId]);

    useSuccessfulCreateSnackbar('Haul Rate Line Item', isSuccess, () => {
        if (orderId || jobId) {
            navigate(`/job/${jobId}/order/${order?.id ?? 'create'}`);
        } else if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`);
        } else {
            navigate(`/quotes`);
        }
    });
    useFailedCreateSnackbar('hauling line item', isError, reset)

    const handleSave = (values: SiteHaulingLineItemDto) => {
        createSiteHaulingLineItem(values);
    };

    const handleCancel = () => {
        if (orderId || jobId) {
            navigate(`/job/${jobId}/order/${order?.id ?? 'create'}`);
        } else if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`)
        } else {
            navigate('/quotes');
        }
    };

    if (isQuoteLoading || isOrderLoading || quote === undefined) {
        return <LoadingIndicator />;
    }

    return <SiteHaulingLineItemForm save={handleSave} cancel={handleCancel} quote={quote} order={order} initValues={DEFAULT_SITE_HAULING_LINE_ITEM} />;
};
